export default {
  toastr: {
    cloud_license: {
      update_error_internal_use: 'The internal use change could not be completed'
    },
    create_error: 'An error occurred while creating {{model}}. Fix the errors and try again',
    create_error_default: 'An error occurred while creating {{model}}.',
    create_successful: '{{model}} was created successfully',
    delete_error: 'An error occurred while deleting {{model}}',
    delete_successful: '{{model}} successfully deleted',
    cancel_successful: '{{model}} successfully canceled',
    unauthorized_successful: '{{model}} successfully unauthorized',
    auth_successful: '{{model}} successfully authorized',
    ont_authorization: {
      success: 'The ONT of contract {{contract}} was successfully authorized.',
      error: 'An error occurred during the authorization of the ONT of contract {{contract}}.',
      open_applied_changes: 'Open Applied Changes'
    },
    link_successful: '{{model}} successfully linked',
    update_onu_successful: '{{model}} was updated successfully',
    change_password_successful: 'Password was updated successfully',
    change_ssid_successful: 'SSID was updated successfully',
    errors: {
      invalid: 'Something went wrong, please contact support'
    },
    form_has_errors: 'There are errors in the form. Fix the errors and try again',
    invoicing_firm: {
      colombia: {
        siigo: {
          payment_way_invalid: 'Invalid payment way',
          payment_ways_linked_successfully: 'Payment ways linked successfully'
        }
      },
      ecuador: {
        contifico: {
          payment_way_invalid: 'Invalid payment way',
          payment_ways_linked_successfully: 'Payment ways linked successfully'
        }
      }
    },
    news_notification: {
      publish: 'The news was sent to be published correctly'
    },
    sent_successfully: '{{model}} was sent successfully',
    service_invoice: {
      generate_service_invoice: {
        success: {
          header: 'Periodic invoice',
          body: 'The periodic invoice was successfully generated'
        }
      },
      cancel_initial_invoice: {
        success: {
          header: 'Initial invoice',
          body: 'The initial invoice generation message will not be displayed again'
        }
      }
    },
    subscription: {
      create_subscription: 'Successful subscription',
      subscription_cancelled: 'Subscription cancelled'
    },
    uniq_code_numeric: {
      assign_successful: 'CUN assigned successfully',
      create_successful: 'The CUN format was created successfully',
      delete_successful: 'The CUN format was successfully deleted',
      update_successful: 'The CUN format was updated successfully'
    },
    update_error: 'An error occurred while updating {{model}}. Fix the errors and try again',
    update_successful: '{{model}} was updated successfully',
    verifying_model: 'Verifying {{model}}'
  }
};
